import {PayloadAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import giftUrlApi from "../helpers/giftUrlApi";
import {GiftEntityPaymentTypes} from "../constants/payment";
import {getGiftCollectionByProfile} from "../helpers/getGiftCollectionByProfile";
import { UpdateGiftRequest, InitGiftRequest, GiftContact, IContactAccount } from "../constants/IGift";

export const initGiftRequest = createAsyncThunk("giftSending/init", async (req: InitGiftRequest) => {
    let gift
    try {
        if (!req?.attachments) return
        if (req?.attachments?.[0]?.type === GiftEntityPaymentTypes.calendar) {
            let newCalendarId = await giftUrlApi().copyCalendarForGift({
                calendarId: req.attachments[0].attachmentId
            })
            req.attachments[0].attachmentId = newCalendarId
            gift = await giftUrlApi().createGift(req)
        } else {
            const giftCollectionId = await getGiftCollectionByProfile(req.userId)
            let newCardId = await giftUrlApi().copyCardForGift({
                userId: req.userId,
                cardId: req.attachments[0].attachmentId,
                collectionId: giftCollectionId || req.attachments[0].collectionId
            })
            req.attachments[0].attachmentId = newCardId
            gift = await giftUrlApi().createGift(req)
        }
    } catch (e) {
        console.log(e)
    } finally {
        return gift
    }
})

export const updateGiftRequest = createAsyncThunk("giftSending/update", async (req: UpdateGiftRequest & {shouldUpdateCard: boolean}) => {
    let gift
    try {
        if (req?.attachments && req.shouldUpdateCard) {
            if (req?.attachments?.[0]?.type === GiftEntityPaymentTypes.calendar) {
                let newCalendarId = await giftUrlApi().copyCalendarForGift({
                    calendarId: req.attachments[0].attachmentId
                })
                req.attachments[0].attachmentId = newCalendarId
                gift = await giftUrlApi().updateGift(req)
            } else {
                const giftCollectionId = await getGiftCollectionByProfile(req.sender.accountId)
                let newCardId = await giftUrlApi().copyCardForGift({
                    userId: req.sender.accountId,
                    cardId: req.attachments[0].attachmentId,
                    collectionId: giftCollectionId
                })
                req.attachments[0].attachmentId = newCardId
                gift = await giftUrlApi().updateGift(req)
            }
        } else {
            gift = await giftUrlApi().updateGift(req)
        }
    } catch (e) {
        console.log(e)
    } finally {
        return gift
    }
});

interface GiftSendingInitial {
    req: {
        recipient: GiftContact | null,
        text: string,
        paymentMethod: "real" | "tugriks"
    },
    res: any,
    recipientContact: IContactAccount | null,
    newContactNumber: string
    newContactNumberRaw: string
    originalCardId: string | null,
    loading: boolean,
    error: any
}

const initialState: GiftSendingInitial = {
    req: {
        recipient: null,
        text: "",
        paymentMethod: "real",
    },
    res: null,
    recipientContact: null,
    newContactNumber: "",
    newContactNumberRaw: "",
    originalCardId: null,
    loading: false,
    error: null
}

const sendGiftSlice = createSlice({
    name: "giftSending",
    initialState,
    reducers: {
        setRecipient(state, action: PayloadAction<GiftContact | null>) {
            state.req.recipient = action.payload
        },
        setRecipientContact(state, action: PayloadAction<IContactAccount | null>) {
            state.recipientContact = action.payload
        },
        setOriginalCardId(state, action: PayloadAction<string>) {
            state.originalCardId = action.payload
        },
        setText(state, action) {
            state.req.text = action.payload
        },
        setNewContactNumber(state, action) {
            state.newContactNumber = action.payload
        },
        setNewContactNumberRaw(state, action) {
            state.newContactNumberRaw = action.payload
        },
        setPaymentMethod(state, action) {
            state.req.paymentMethod = action.payload
        },
        setGift(_, action) {
            return action.payload
        },
        clearGiftSend: () => initialState
    },
    extraReducers: {
        [initGiftRequest.fulfilled.toString()]: (state, action) => {
            state.res = action.payload;
            state.loading = false;
        },
        [initGiftRequest.rejected.toString()]: (state, action) => {
            state.error = action.payload
            state.loading = false;
        },
        [initGiftRequest.pending.toString()]: state => {
            state.loading = true;
        },
        [updateGiftRequest.fulfilled.toString()]: (state, action) => {
            state.res = action.payload;
            state.loading = false;
        },
        [updateGiftRequest.rejected.toString()]: (state, action) => {
            state.error = action.payload
            state.loading = false;
        },
        [updateGiftRequest.pending.toString()]: state => {
            state.loading = true;
        },
    }
});

export default sendGiftSlice;

export const selectorSendGift = (state: any): GiftSendingInitial => state.sendGift

export const {
    setPaymentMethod,
    setRecipient,
    setRecipientContact,
    setText,
    clearGiftSend,
    setOriginalCardId,
    setNewContactNumber,
    setNewContactNumberRaw,
    setGift
} = sendGiftSlice.actionsimport {PayloadAction, createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import giftUrlApi from "../helpers/giftUrlApi";
import {GiftEntityPaymentTypes} from "../constants/payment";
import {getGiftCollectionByProfile} from "../helpers/getGiftCollectionByProfile";
import { UpdateGiftRequest, InitGiftRequest, GiftContact, IContactAccount } from "../constants/IGift";

export const initGiftRequest = createAsyncThunk("giftSending/init", async (req: InitGiftRequest) => {
    let gift
    try {
        if (!req?.attachments) return
        if (req?.attachments?.[0]?.type === GiftEntityPaymentTypes.calendar) {
            let newCalendarId = await giftUrlApi().copyCalendarForGift({
                calendarId: req.attachments[0].attachmentId
            })
            req.attachments[0].attachmentId = newCalendarId
            gift = await giftUrlApi().createGift(req)
        } else {
            const giftCollectionId = await getGiftCollectionByProfile(req.userId)
            let newCardId = await giftUrlApi().copyCardForGift({
                userId: req.userId,
                cardId: req.attachments[0].attachmentId,
                collectionId: giftCollectionId || req.attachments[0].collectionId
            })
            req.attachments[0].attachmentId = newCardId
            gift = await giftUrlApi().createGift(req)
        }
    } catch (e) {
        console.log(e)
    } finally {
        return gift
    }
})

export const updateGiftRequest = createAsyncThunk("giftSending/update", async (req: UpdateGiftRequest & {shouldUpdateCard: boolean}) => {
    let gift
    try {
        if (req?.attachments && req.shouldUpdateCard) {
            if (req?.attachments?.[0]?.type === GiftEntityPaymentTypes.calendar) {
                let newCalendarId = await giftUrlApi().copyCalendarForGift({
                    calendarId: req.attachments[0].attachmentId
                })
                req.attachments[0].attachmentId = newCalendarId
                gift = await giftUrlApi().updateGift(req)
            } else {
                const giftCollectionId = await getGiftCollectionByProfile(req.sender.accountId)
                let newCardId = await giftUrlApi().copyCardForGift({
                    userId: req.sender.accountId,
                    cardId: req.attachments[0].attachmentId,
                    collectionId: giftCollectionId
                })
                req.attachments[0].attachmentId = newCardId
                gift = await giftUrlApi().updateGift(req)
            }
        } else {
            gift = await giftUrlApi().updateGift(req)
        }
    } catch (e) {
        console.log(e)
    } finally {
        return gift
    }
});

interface GiftSendingInitial {
    req: {
        recipient: GiftContact | null,
        text: string,
        paymentMethod: "real" | "tugriks"
    },
    res: any,
    recipientContact: IContactAccount | null,
    newContactNumber: string
    newContactNumberRaw: string
    originalCardId: string | null,
    loading: boolean,
    error: any
}

const initialState: GiftSendingInitial = {
    req: {
        recipient: null,
        text: "",
        paymentMethod: "real",
    },
    res: null,
    recipientContact: null,
    newContactNumber: "",
    newContactNumberRaw: "",
    originalCardId: null,
    loading: false,
    error: null
}

const sendGiftSlice = createSlice({
    name: "giftSending",
    initialState,
    reducers: {
        setRecipient(state, action: PayloadAction<GiftContact | null>) {
            state.req.recipient = action.payload
        },
        setRecipientContact(state, action: PayloadAction<IContactAccount | null>) {
            state.recipientContact = action.payload
        },
        setOriginalCardId(state, action: PayloadAction<string>) {
            state.originalCardId = action.payload
        },
        setText(state, action) {
            state.req.text = action.payload
        },
        setNewContactNumber(state, action) {
            state.newContactNumber = action.payload
        },
        setNewContactNumberRaw(state, action) {
            state.newContactNumberRaw = action.payload
        },
        setPaymentMethod(state, action) {
            state.req.paymentMethod = action.payload
        },
        setGift(_, action) {
            return action.payload
        },
        clearGiftSend: () => initialState
    },
    extraReducers: {
        [initGiftRequest.fulfilled.toString()]: (state, action) => {
            state.res = action.payload;
            state.loading = false;
        },
        [initGiftRequest.rejected.toString()]: (state, action) => {
            state.error = action.payload
            state.loading = false;
        },
        [initGiftRequest.pending.toString()]: state => {
            state.loading = true;
        },
        [updateGiftRequest.fulfilled.toString()]: (state, action) => {
            state.res = action.payload;
            state.loading = false;
        },
        [updateGiftRequest.rejected.toString()]: (state, action) => {
            state.error = action.payload
            state.loading = false;
        },
        [updateGiftRequest.pending.toString()]: state => {
            state.loading = true;
        },
    }
});

export default sendGiftSlice;

export const selectorSendGift = (state: any): GiftSendingInitial => state.sendGift

export const {
    setPaymentMethod,
    setRecipient,
    setRecipientContact,
    setText,
    clearGiftSend,
    setOriginalCardId,
    setNewContactNumber,
    setNewContactNumberRaw,
    setGift
} = sendGiftSlice.actions